<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>Thermal Print Settings</v-toolbar-title>
    	</v-toolbar>

	    <div class="hasToolbar">
	    	
	    	<div class="switches" white-background>
                <v-list two-line nopadding>
                    <v-list-tile class="padding-right-8">

                        <v-list-tile-content>
                            <v-list-tile-title>Enable Thermal Print</v-list-tile-title>
                            <v-list-tile-sub-title>Enable thermal print</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-switch style="padding: 0 !important;" @change="fn_toggleThermalPrint" v-model="ThermalPrintSettings.enableThermalPrint" nomargin></v-switch>
                        </v-list-tile-action>

                    </v-list-tile>
                </v-list>

                <template v-if="ThermalPrintSettings.enableThermalPrint">
                    <v-list nopadding>
                        <v-subheader grey-back>Print Settings</v-subheader>

                        <v-list-tile class="padding-right-8" @click="fn_toDevices">

                            <v-list-tile-content>
                                <v-list-tile-title>Select Printer</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action style="display: flex; flex-direction: row; align-items: flex-end;">
                                {{ defaultPrinter }} <v-icon font20>chevron_right</v-icon>
                                <!-- <v-switch style="padding: 0 !important;" @change="fn_toggleThermalPrint" v-model="ThermalPrintSettings.enableThermalPrint" nomargin></v-switch> -->
                            </v-list-tile-action>

                        </v-list-tile>

						<v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Printer Connection</v-list-tile-title>
                            </v-list-tile-content>

                            <v-menu style="border-radius: 5px;">
                                <v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
                                    <v-chip class="pr-1" small>{{ ThermalPrintSettings.connectionType == 'USB' ? 'USB' : 'Bluetooth' }}<v-icon class="font20">arrow_drop_down</v-icon></v-chip>
                                </v-list-tile-action>

                                <v-list nopadding>
                                    <template>
										<v-list-tile @click="fn_setConnectionType('Bluetooth')">
                                            <v-list-tile-content>
                                                <v-list-tile-title>Bluetooth</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile @click="fn_setConnectionType('USB')">
                                            <v-list-tile-content>
                                                <v-list-tile-title>USB</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-menu>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Number of Copies</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-text-field label="" placeholder="1" :hide-details="false" class="ma-0 pa-0" style="width: 80px;" type="number" v-model="ThermalPrintSettings.numberOfCopies" @input="fn_saveNumberOfCopies"></v-text-field>
                                <!-- <input type="number" placeholder="1" style="width: 80px;"> -->
                                <!-- <v-switch style="padding: 0 !important;" @change="fn_toggleThermalPrint" v-model="ThermalPrintSettings.enableThermalPrint" nomargin></v-switch> -->
                            </v-list-tile-action>

                            </v-list-tile>

                            <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Extra lines at end of print</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-text-field label="" placeholder="1" :hide-details="false" class="ma-0 pa-0" style="width: 80px;" type="number" @input="fn_saveLinesAtEnd" v-model="ThermalPrintSettings.linesAtEnd"></v-text-field>
                                <!-- <input type="number" placeholder="1" style="width: 80px;"> -->
                                <!-- <v-switch style="padding: 0 !important;" @change="fn_toggleThermalPrint" v-model="ThermalPrintSettings.enableThermalPrint" nomargin></v-switch> -->
                            </v-list-tile-action>

                            </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Page Size</v-list-tile-title>
                            </v-list-tile-content>

                            <v-menu style="border-radius: 5px;">
                                <v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
                                    <v-chip class="pr-1" small>{{ ThermalPrintSettings.pageSize ? fn_getPageSize() : "3 Inch (80mm)"}} <v-icon class="font20">arrow_drop_down</v-icon></v-chip>
                                </v-list-tile-action>

                                <v-list nopadding>
                                    <template>
                                        <v-list-tile @click="fn_savePageSize(3)">
                                            <v-list-tile-content>
                                                <v-list-tile-title>3 Inch (80mm)</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
										<v-list-tile @click="fn_savePageSize(2)">
                                            <v-list-tile-content>
                                                <v-list-tile-title>2 Inch (58mm)</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
										<v-list-tile @click="fn_savePageSize(2.1)">
                                            <v-list-tile-content>
                                                <v-list-tile-title>2 Inch Large Font (58mm)</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

										<v-list-tile @click="fn_savePageSize(3.01)">
                                            <v-list-tile-content>
                                                <v-list-tile-title>3 Inch (Compact)</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

										<v-list-tile @click="fn_savePageSize(2.01)">
                                            <v-list-tile-content>
                                                <v-list-tile-title>2 Inch (Compact)</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

										<v-list-tile @click="fn_savePageSize(2.02)">
                                            <v-list-tile-content>
                                                <v-list-tile-title>2 Inch Large Font (Compact)</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

										<!-- <v-list-tile @click="fn_savePageSize(4)">
                                            <v-list-tile-content>
                                                <v-list-tile-title>4 Inch</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

										<v-list-tile @click="fn_savePageSize(4.1)">
                                            <v-list-tile-content>
                                                <v-list-tile-title>4 Inch Large Font</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile> -->
                                    </template>
                                </v-list>
                            </v-menu>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Paper cut after printing</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_togglePaperCut" v-model="ThermalPrintSettings.paperCut" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

						<v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Hide Payment QR</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_togglePaymentQR" v-model="ThermalPrintSettings.hidePaymentQR" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

						<!-- <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Multi-Language Print</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleImagePrint" v-model="ThermalPrintSettings.imagePrint" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile> -->
                    </v-list>

                    <v-list two-line nopadding>

                        <v-subheader grey-back>Header Settings</v-subheader>

                        <v-list-tile class="padding-right-8">

                            <!-- <v-list-tile-action>
                                <v-icon>edit</v-icon>
                            </v-list-tile-action> -->

                            <v-list-tile-content @click="fn_openDialogTextContent('business_name')">
                                <v-list-tile-title>Business Name</v-list-tile-title>
                                <v-list-tile-sub-title>{{ ThermalPrintSettings.thermalBusinessName ? ThermalPrintSettings.thermalBusinessName : $root.CurrentBusiness.BusinessName}}</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                <!-- <v-icon font16>edit</v-icon> -->
                                <v-icon font16>edit</v-icon>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleThermalBusinessName" v-model="ThermalPrintSettings.enableThermalBusinessName" nomargin></v-switch>
                                
                            </v-list-tile-action>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content @click="fn_openDialogTextContent('business_info')">
                                <v-list-tile-title>Business Info</v-list-tile-title>
                                <v-list-tile-sub-title>{{ ThermalPrintSettings.thermalBusinessInfo ? ThermalPrintSettings.thermalBusinessInfo : 'Add Business Info'}}</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                <v-icon font16>edit</v-icon>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleThermalBusinessInfo" v-model="ThermalPrintSettings.enableThermalBusinessInfo" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Business Logo</v-list-tile-title>
                                <v-list-tile-sub-title>Enable/Disable business logo</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleThermalBusinessLogo" v-model="ThermalPrintSettings.enableThermalBusinessLogo" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Customer Details</v-list-tile-title>
                                <v-list-tile-sub-title>Enable/Disable Customer Info</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleThermalCustomerInfo" v-model="ThermalPrintSettings.enableThermalCustomerInfo" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Other Fields</v-list-tile-title>
                                <v-list-tile-sub-title>P.O No/Transporter and Other Fields</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleThermalOtherFields" v-model="ThermalPrintSettings.enableThermalOtherFields" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

                    </v-list>

                    <v-list nopadding>

                        <v-subheader grey-back>Item Settings</v-subheader>
                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Item Description</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleItemDescription" v-model="ThermalPrintSettings.itemDescription" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Item Note</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleItemNote" v-model="ThermalPrintSettings.itemNote" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Brand</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleItemBrand" v-model="ThermalPrintSettings.itemBrand" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Company</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleItemCompany" v-model="ThermalPrintSettings.itemCompany" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Category</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleItemCategory" v-model="ThermalPrintSettings.itemCategory" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Unit</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleItemUnit" v-model="ThermalPrintSettings.itemUnit" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

                        <v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Item Code</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleItemCode" v-model="ThermalPrintSettings.itemCode" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

						<v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Rate</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleItemRate" v-model="ThermalPrintSettings.itemRate" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

						<v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Discount</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleItemDiscount" v-model="ThermalPrintSettings.itemDiscount" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

						<v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>GST</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleItemGST" v-model="ThermalPrintSettings.itemGst" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>

						<v-list-tile class="padding-right-8">

                            <v-list-tile-content>
                                <v-list-tile-title>Item Net Amount</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-switch style="padding: 0 !important;" @change="fn_toggleItemNetAmount" v-model="ThermalPrintSettings.itemNetAmount" nomargin></v-switch>
                            </v-list-tile-action>

                        </v-list-tile>
                    </v-list>

                    <v-list two-line nopadding>
                            <v-subheader grey-back>Footer Settings</v-subheader>
                            <!-- <template v-if="ThermalPrintSettings.enableThermalPrint"> -->

                            <v-list-tile class="padding-right-8">

                                <v-list-tile-content>
                                    <v-list-tile-title>Remaining Amount</v-list-tile-title>
                                    <v-list-tile-sub-title>Enable/Disable remaining amount</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action>
                                    <v-switch style="padding: 0 !important;" @change="fn_toggleRemainingAmount" v-model="ThermalPrintSettings.remainingAmount" nomargin></v-switch>
                                </v-list-tile-action>

                                </v-list-tile>
                                <v-list-tile class="padding-right-8">

                                    <v-list-tile-content>
                                        <v-list-tile-title>Tax Summary</v-list-tile-title>
                                        <v-list-tile-sub-title>Enable/Disable Tax Summary</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-switch style="padding: 0 !important;" @change="fn_toggleThermalTaxSummary" v-model="ThermalPrintSettings.enableThermalTaxSummary" nomargin></v-switch>
                                    </v-list-tile-action>

                                </v-list-tile>

                                <v-list-tile class="padding-right-8">

                                    <v-list-tile-content>
                                        <v-list-tile-title>Invoice Note</v-list-tile-title>
                                        <v-list-tile-sub-title>Enable/Disable Invoice Note</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-switch style="padding: 0 !important;" @change="fn_toggleThermalInvoiceNote" v-model="ThermalPrintSettings.enableThermalInvoiceNote" nomargin></v-switch>
                                    </v-list-tile-action>

                                </v-list-tile>

                                <v-list-tile class="padding-right-8">

                                    <v-list-tile-content @click="fn_openDialogTextContent('yousaved')">
                                        <v-list-tile-title>Saving Text</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ ThermalPrintSettings.thermalSavingText ? ThermalPrintSettings.thermalSavingText : 'You Saved' }}</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                        <v-icon font16>edit</v-icon>
                                        <v-switch style="padding: 0 !important;" @change="fn_toggleThermalSavingText" v-model="ThermalPrintSettings.enableThermalSavingText" nomargin></v-switch>
                                    </v-list-tile-action>

                                </v-list-tile>

                                <v-list-tile class="padding-right-8">

                                    <v-list-tile-content @click="fn_openDialogTextContent('terms')">
                                        <v-list-tile-title>Terms &amp; Conditions</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ ThermalPrintSettings.thermalTermsText ? ThermalPrintSettings.thermalTermsText : 'All disputes are subject to '+ $root.CurrentBusiness.State +' jurisdiction'}}</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                        <v-icon font16>edit</v-icon>
                                        <v-switch style="padding: 0 !important;" @change="fn_toggleThermalTerms" v-model="ThermalPrintSettings.enableThermalTerms" nomargin></v-switch>
                                    </v-list-tile-action>

                                </v-list-tile>

                                <v-list-tile class="padding-right-8">

                                    <v-list-tile-content @click="fn_openDialogTextContent('greeting')">
                                        <v-list-tile-title>Footer Message</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ ThermalPrintSettings.thermalGreetingText ? ThermalPrintSettings.thermalGreetingText : 'Thank you! Visit again soon!'}}</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                        <v-icon font16>edit</v-icon>
                                        <v-switch style="padding: 0 !important;" @change="fn_toggleThermalGreetingMessage" v-model="ThermalPrintSettings.enableThermalGreetingMessage" nomargin></v-switch>
                                    </v-list-tile-action>

                                </v-list-tile>

								<v-list-tile class="padding-right-8">

                                    <v-list-tile-content>
                                        <v-list-tile-title>Invoice Total Bold &amp; Bigger</v-list-tile-title>
                                        <v-list-tile-sub-title>Make invoice total bold and bigger</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-switch style="padding: 0 !important;" @change="fn_toggleBiggerTotal" v-model="ThermalPrintSettings.invoiceTotalBigger" nomargin></v-switch>
                                    </v-list-tile-action>

                                </v-list-tile>

                            <!-- </template> -->
                        <!-- </template> -->
                    </v-list>
                </template>
	    	</div>

	    </div>

		<dialog-text ref="ref_dialogText" :title="textDialogTitle" :type="textDialogType" :textContent="dialogTextContent"></dialog-text>

	</div>
</template>

<script>
const dialogjs =  require('../../masters/forms/dialog').dialogjs;
// const accountGroupIds = require('../../../config.js').configs.accountGroupIds;
// import dialogConfirmation from '../../dialogs/dialog_confirmation'
import dialogText from '../../dialogs/dialog_text'

	export default{
		data(){
			return{
				ThermalPrintSettings:{
                    "enableThermalPrint":false, 
                    "enableThermalTaxSummary":true, 
                    "enableThermalSavingText":true, 
                    "enableThermalTerms":true, 
                    "enableThermalInvoiceNote":true, 
                    "enableThermalGreetingMessage":true, 
                    "thermalSavingText":null, 
                    "thermalTermsText":null, 
                    "thermalGreetingText":null, 
                    "enableThermalInvoiceNote":true, 
					"pageSize":3,
                    

                    "itemDescription":true,
                    "itemNote":true,
                    "itemBrand":true,
                    "itemCompany":true,
                    "itemCategory":true,
                    "itemUnit":true,
                    "itemCode":true,
					"itemRate":true,
					"itemDiscount":true,
					"itemGst":true,
					"itemNetAmount":true,

                    // print settings
                    "numberOfCopies":1,
                    "paperCut":false,
                    "linesAtEnd":1,

                    // header settings
                    "enableThermalBusinessName":null, 
                    "thermalBusinessName":null,
                    "enableThermalBusinessInfo":null, 
                    "thermalBusinessInfo":null,
                    "enableThermalBusinessLogo":true,
                    "enableThermalCustomerInfo":true,
                    "enableThermalOtherFields":true,
					"invoiceTotalBigger":false,
					"connectionType":null,
					"imagePrint":false
                },
				formId:null,
				askToQuit:false,
				textDialogType:null,
				textDialogTitle:null,
				dialogTextContent:null,
                defaultPrinter:null
			}
		},
		components:{
			// 'dialog-confirmation': dialogConfirmation,
			'dialog-text':dialogText
		},
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_openDialogConfirmation: function(){
				this.fn_openDialogWeb('web', 'DiscardDialog', 'ref_dialogConfirmation');
			},

			fn_discard: function(){
				this.fn_closeDialog();
				this.askToQuit = false;
				let self = this;
				setTimeout(function(){
					self.$router.go(-1);
				},300);
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var dialogObj = {};
				dialogObj.tagId = this.guidWeb();
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialog: function(){
				this.askToQuit = false;
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkTaxMode: function(){
				let self = this;
				let filterObject = {};
				filterObject.transactionTypeId = [10001, 10002, 10003, 10004, 100005];
				filterObject.taxMode = this.ThermalPrintSettings.gstType;
				this.getFilterData('CheckTaxMode', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let isSimilar = JSON.parse(response);
							!isSimilar ? self.ThermalPrintSettings.gstType = -1 : '';
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			fn_selectDefaultPaymentMode: function(item){
				this.selectedPaymentMode = item;
				this.ThermalPrintSettings.defaultPaymentMode = item.value;
				this.fn_post();
			},

			fn_setEwayBillConfigValue: function(val){
				this.ThermalPrintSettings.eWayBillConfigValue = val;
				this.fn_post();
			},

            fn_toggleNumberSeriesTypeWise: function(val){
                let self = this;
                let typeArr = null;
				let title = "Tax Invoice";
				let taxMode = 1;
				if(this.$root.CurrentBusiness.GSTRegistrationStatus == 2){
					title = "Bill of Supply";
					taxMode = 0;
				}
				else if(this.$root.CurrentBusiness.GSTRegistrationStatus == 3){
					title = "Invoice";
					taxMode = 0;
				}
                if(val){
                    typeArr = [
                        // Retail Invoice
                        {"accountData":null,"additionalData":null,"central":true,"centralTransactionAccountId":"41f99d4b-e806-422b-8036-8ecb8ba3e24d","fieldsData":null,"importExport":false,"importExportTransactionAccountId":null,"inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":true,"localTransactionAccountId":"90470ef2-7d52-4707-80d4-24c4cb28d768","name":"Retail Invoice","numberSeriesId":"a431fe26-0dc5-4e6d-981d-45bd1ce24a3b","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":0,"transactionNature":null,"transactionTypeFormId":"33e66294-8148-1b9e-0090-50aa87b20cb5","transactionTypeId":10003,"isSystem":1,"isDefault":true},
                        // Wholesale Invoice
                        {"accountData":null,"additionalData":null,"central":true,"centralTransactionAccountId":"41f99d4b-e806-422b-8036-8ecb8ba3e24d","fieldsData":null,"importExport":false,"importExportTransactionAccountId":null,"inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":true,"localTransactionAccountId":"90470ef2-7d52-4707-80d4-24c4cb28d768","name":"Wholesale Invoice","numberSeriesId":"690f3302-ce57-4439-b739-b90d1d257789","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":1,"transactionNature":null,"transactionTypeFormId":"757c506e-9a73-e012-2632-4c29b0c0ac18","transactionTypeId":10003,"isSystem":1,"isDefault":false},
                        // Export Invoice
                        {"accountData":null,"additionalData":null,"central":false,"centralTransactionAccountId":null,"fieldsData":null,"importExport":true,"importExportTransactionAccountId":"daf504a8-8355-4985-b414-505471c895b1","inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":false,"localTransactionAccountId":null,"name":"Export Invoice","numberSeriesId":"db95e074-d5e6-43c4-af4e-41e7cb101d84","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":1,"transactionNature":null,"transactionTypeFormId":"5ed488ce-ed95-6d93-96d0-3cc463951983","transactionTypeId":10003,"isSystem":1,"isDefault":false}
                    ]
                }
                else{
                    typeArr = [
                        // Retail Invoice
                        {"accountData":null,"additionalData":null,"central":true,"centralTransactionAccountId":"41f99d4b-e806-422b-8036-8ecb8ba3e24d","fieldsData":null,"importExport":false,"importExportTransactionAccountId":null,"inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":true,"localTransactionAccountId":"90470ef2-7d52-4707-80d4-24c4cb28d768","name":"Retail Invoice","numberSeriesId":"1af6f388-e3c1-2cba-11df-7138cd7a5c1e","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":0,"transactionNature":null,"transactionTypeFormId":"33e66294-8148-1b9e-0090-50aa87b20cb5","transactionTypeId":10003,"isSystem":1,"isDefault":true},
                        // Wholesale Invoice
                        {"accountData":null,"additionalData":null,"central":true,"centralTransactionAccountId":"41f99d4b-e806-422b-8036-8ecb8ba3e24d","fieldsData":null,"importExport":false,"importExportTransactionAccountId":null,"inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":true,"localTransactionAccountId":"90470ef2-7d52-4707-80d4-24c4cb28d768","name":"Wholesale Invoice","numberSeriesId":"1af6f388-e3c1-2cba-11df-7138cd7a5c1e","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":1,"transactionNature":null,"transactionTypeFormId":"757c506e-9a73-e012-2632-4c29b0c0ac18","transactionTypeId":10003,"isSystem":1,"isDefault":false},
                        // Export Invoice
                        {"accountData":null,"additionalData":null,"central":false,"centralTransactionAccountId":null,"fieldsData":null,"importExport":true,"importExportTransactionAccountId":"daf504a8-8355-4985-b414-505471c895b1","inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":false,"localTransactionAccountId":null,"name":"Export Invoice","numberSeriesId":"1af6f388-e3c1-2cba-11df-7138cd7a5c1e","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":1,"transactionNature":null,"transactionTypeFormId":"5ed488ce-ed95-6d93-96d0-3cc463951983","transactionTypeId":10003,"isSystem":1,"isDefault":false}
                    ]
                }

                let postObj = {"transactionsType":typeArr};
                
                this.postData('TransactionTypeList', postObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
                            self.fn_post();
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
            },

			fn_post: function(){
                let dataObj = {LocalKey:'ThermalPrintSettings',LocalValue:JSON.stringify(this.ThermalPrintSettings)}
				this.$root.fn_saveLocalItem(dataObj, ()=>{
                    this.$root.fn_getLocalItem('ThermalPrintSettings', response=>{
						let data = JSON.parse(response);
						if(data && data.LocalValue){
							this.$root.ThermalPrintSettings = JSON.parse(data.LocalValue);
								if(this.$root.ThermalPrintSettings && this.$root.ThermalPrintSettings.enableThermalPrint){
								this.$root.fn_openThermalView();
							}
						}
                    });
                    this.showToast("Settings Updated");
                });
			},

			fn_toggleParties: function(val){
				if(val){
					this.fn_addParties();
				}
				else{
					this.fn_removeParties();
				}
			},

			fn_addParties: function(val){
                let self = this;
                let partyGroups = [
					// entering creditor in sale forms
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"757c506e-9a73-e012-2632-4c29b0c0ac18","transactionTypePartyId":"910ede56-41c4-40cd-a0b7-82274dc0c071","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"33e66294-8148-1b9e-0090-50aa87b20cb5","transactionTypePartyId":"4bf238a8-086c-4716-9703-cae8bde11827","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"5ed488ce-ed95-6d93-96d0-3cc463951983","transactionTypePartyId":"8d80f210-73cb-45c2-913a-ca816f3ac284","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"e295c554-1dd5-e4f8-e8b7-4dacb7a096d6","transactionTypePartyId":"9626cb3f-b30f-4864-9a16-77dbf8c2c85c","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"e7e62fe1-3e70-49d1-a887-bf68953f48d8","transactionTypePartyId":"cbba4fbf-b6a2-454c-b0c8-679d4b2d96a0","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"e1dbb78d-995c-5f21-f845-03ca42de805b","transactionTypePartyId":"efab1ab3-96da-4d92-98cc-f996a44c92de","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"425524a0-8d67-7804-fbc9-3e7cca2a82bf","transactionTypePartyId":"8c0bca10-f1cf-4b40-aa69-9f794aa2dd19","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"400eddc0-9277-7d0d-5806-68c4507b8ac3","transactionTypePartyId":"5e9fa9d3-46f7-4b98-b55c-a92a6cdfbede","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"1e61de0c-bdd7-4e51-7758-4fccfdcea829","transactionTypePartyId":"bf21fe75-1eed-46c1-8f13-488bb6e71f87","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"208c0d5c-da96-4593-e126-f2e00a9f58fb","transactionTypePartyId":"c22bdfac-3c79-4274-8e30-13f5bcd5c2ad","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"bb87606a-d063-4275-afb9-1cbadd1c78d0","transactionTypePartyId":"692da9c5-5cbe-4ca1-abde-8b593b55e305","isSystem":1},
					// entering debtor in purchase forms
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"9fb8a5ce-349a-787d-3111-243bcb648811","transactionTypePartyId":"73cbec33-ba72-4af0-a605-d4a8050267e8","isSystem":1},
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"97c5c10f-8fe0-e426-d970-38046569e5c8","transactionTypePartyId":"a68d88b7-ff35-4edb-895a-f5822ea67ee4","isSystem":1},
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"a2ca4fe2-a8cf-4ed0-926c-1b0801790914","transactionTypePartyId":"d0a0399c-b290-44f0-a405-5ffe46e4a74c","isSystem":1},
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"b8397f7f-d416-0e62-6cd2-09b6a1f88ea4","transactionTypePartyId":"b83b916c-cf5d-4fe9-ab06-6f96d8797ee9","isSystem":1},
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"d703ed08-b9c0-bc86-96da-3764d53b9779","transactionTypePartyId":"3c38f294-a282-4a7e-ae31-704267860612","isSystem":1},
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"6b332fcd-59f7-28db-845c-06d7a8613f78","transactionTypePartyId":"58989bb2-8f67-42a9-921d-884f1ccd98c4","isSystem":1}
				];
				

                let postObj = {"transactionsTypeParties":partyGroups};
                
                this.postData('TransactionTypeParty', postObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
                            self.fn_post();
				        },
				        onError: function(error){
				          console.log(error);
						  self.showToast("Something went wrong");
						  self.ThermalPrintSettings.showAllParties = !self.ThermalPrintSettings.showAllParties;
				        }
					}
		        );
            },

			fn_removeParties: function(){
				let postObj = {	
					transactionsTypePartyIds:[
						"910ede56-41c4-40cd-a0b7-82274dc0c071",
						"4bf238a8-086c-4716-9703-cae8bde11827",
						"8d80f210-73cb-45c2-913a-ca816f3ac284",
						"9626cb3f-b30f-4864-9a16-77dbf8c2c85c",
						"cbba4fbf-b6a2-454c-b0c8-679d4b2d96a0",
						"efab1ab3-96da-4d92-98cc-f996a44c92de",
						"8c0bca10-f1cf-4b40-aa69-9f794aa2dd19",
						"5e9fa9d3-46f7-4b98-b55c-a92a6cdfbede",
						"bf21fe75-1eed-46c1-8f13-488bb6e71f87",
						"c22bdfac-3c79-4274-8e30-13f5bcd5c2ad",
						"692da9c5-5cbe-4ca1-abde-8b593b55e305",
						"73cbec33-ba72-4af0-a605-d4a8050267e8",
						"a68d88b7-ff35-4edb-895a-f5822ea67ee4",
						"d0a0399c-b290-44f0-a405-5ffe46e4a74c",
						"b83b916c-cf5d-4fe9-ab06-6f96d8797ee9",
						"3c38f294-a282-4a7e-ae31-704267860612",
						"58989bb2-8f67-42a9-921d-884f1ccd98c4"
					]
				}
				let self = this;
				this.postFilterData('deleteTransactionTypeParty', null, postObj, 
					{
						onSuccess: function(response){
							console.log(response);
							self.fn_post();
						}, 
						onError: function(error){
							console.log(error);
							self.showToast("Something went wrong");
							self.ThermalPrintSettings.showAllParties = !self.ThermalPrintSettings.showAllParties;
						}
					}
				);
			},

			fn_changePageSize: function(pageSize){
				this.ThermalPrintSettings.printPageSize = pageSize;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_setConnectionType: function(value){
				this.ThermalPrintSettings.connectionType = value;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_transactionDate: function(value){
				this.ThermalPrintSettings.transactionDateStatus = value;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_toggleLogoStatement: function(value){
				this.ThermalPrintSettings.removeLogoFromStatement = value;
				this.fn_post();
			},

			fn_toggleNotesInStatement: function(value){
				this.ThermalPrintSettings.ledgerStatementNotes = value;
				this.fn_post();
			},

			fn_changeEstimateTitle: function(value){
				this.ThermalPrintSettings.estimatePrintTitle = value;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_changeSaleReturnTitle: function(value){
				this.ThermalPrintSettings.saleReturnPrintTitle = value;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_changePurchaseReturnTitle: function(value){
				this.ThermalPrintSettings.purchaseReturnPrintTitle = value;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_toggleAutoRoundOff: function(value){
				this.ThermalPrintSettings.isAutoRoundOff = value;
				this.fn_post();
			},

			fn_togglePartyBalance: function(value){
				this.ThermalPrintSettings.showPartyBalance = value;
				this.fn_post();
			},

			fn_togglePrescribeDetails: function(value){
				this.ThermalPrintSettings.enablePrescribeDetails = value;
				if(value){
					this.fn_postList();
				}
				this.fn_post();
			},

			fn_toggleBarcodeScan: function(value){
				this.ThermalPrintSettings.enableBarcodeScan = value;
				this.fn_post();
			},

			fn_toggleThermalPrint: function(value){
				if(value){
					this.ThermalPrintSettings.enableThermalTaxSummary = true;
					this.ThermalPrintSettings.enableThermalSavingText = true;
					this.ThermalPrintSettings.enableThermalTerms = true;
					this.ThermalPrintSettings.enableThermalGreetingMessage = true;
					this.ThermalPrintSettings.enableThermalInvoiceNote = true;
					this.ThermalPrintSettings.enableThermalBusinessName = true;
				}
				this.ThermalPrintSettings.enableThermalPrint = value;
				this.fn_post();
			},

			fn_toggleThermalTaxSummary: function(value){
				this.ThermalPrintSettings.enableThermalTaxSummary = value;
				this.fn_post();
			},

			fn_toggleThermalSavingText: function(value){
				this.ThermalPrintSettings.enableThermalSavingText = value;
				this.fn_post();
			},

			fn_toggleThermalTerms: function(value){
				this.ThermalPrintSettings.enableThermalTerms = value;
				this.fn_post();
			},

			fn_toggleThermalInvoiceNote: function(value){
				this.ThermalPrintSettings.enableThermalInvoiceNote = value;
				this.fn_post();
			},

			fn_toggleThermalGreetingMessage: function(value){
				this.ThermalPrintSettings.enableThermalGreetingMessage = value;
				this.fn_post();
			},

			fn_toggleThermalBusinessName: function(value){
				this.ThermalPrintSettings.enableThermalBusinessName = value;
				this.fn_post();
			},

            fn_toggleThermalBusinessInfo: function(value){
				this.ThermalPrintSettings.enableThermalBusinessInfo = value;
				this.fn_post();
			},

            fn_toggleThermalBusinessLogo: function(value){
				this.ThermalPrintSettings.enableThermalBusinessLogo = value;
				this.fn_post();
			},

            fn_toggleThermalCustomerInfo: function(value){
				this.ThermalPrintSettings.enableThermalCustomerInfo = value;
				this.fn_post();
			},

            fn_toggleThermalOtherFields: function(value){
				this.ThermalPrintSettings.enableThermalOtherFields = value;
				this.fn_post();
			},

			fn_togglePaymentQR: function(value){
				this.ThermalPrintSettings.hidePaymentQR = value;
				this.fn_post();
			},

			fn_changeInvoiceTitle: function(value){
				this.ThermalPrintSettings.invoicePrintTitle = value;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_toggleBatch: function(){
				this.dialogBatchFields = true;
			},

			fn_enableBatchAndFields: function(value){

				let fields = [];
				for(let key in this.batchFields){
					delete this.batchFields[key].selected;
					if(this.batchFields[key].status){
						fields.push(this.batchFields[key]);
					}
				}
				
				if(fields.length == 1 && fields[0].id == 'opening'){
					this.showToast('All fields are disabled');
					return;
				}
				

				// this.ThermalPrintSettings.batchFields = [];
				this.ThermalPrintSettings.batchFields = JSON.parse(JSON.stringify(fields));

				// for(let key in this.batchFields){
				// 	delete this.batchFields[key].selected;
				// 	if(this.batchFields[key].status){
				// 		this.ThermalPrintSettings.batchFields.push(this.batchFields[key]);
				// 	}
				// }
				// this.batchFields.forEach(item=>{
				// 	delete item.selected;
				// 	if(item.status){
				// 		this.ThermalPrintSettings.batchFields.push(item);
				// 	}
				// })

				// for(let i=0; i<this.batchFields.length; i++){
				// 	delete this.batchFields[i].selected;
				// 	if(this.batchFields[i].status){
				// 		this.ThermalPrintSettings.batchFields.push(JSON.parse(JSON.stringify(this.batchFields[i])));
				// 	}
				// }
				

				if(value === true){
					this.dialogBatchFields = true;
				}
				else{
					this.dialogBatchFields = false;
				}

				this.reorder = false;
				// this.dialogBatchFields = false;
				this.fn_post();
			},

			fn_selectToReorder: function(obj){
				if(this.reorder){
					// for(let key in this.batchFields){
					// 	this.batchFields[key].selected = false;
					// }
					this.batchFields.forEach(item => {
						item.selected = false;
					});
					obj.selected = true;
					this.$forceUpdate();
				}
			},

			fn_moveField: function(type){
				let itemIndex = this.batchFields.findIndex(item=>{return item.selected});
				let tempItem = this.batchFields[itemIndex];
				this.batchFields.splice(itemIndex, 1);
				let insertIndex = type == 'up' ? itemIndex - 1 : itemIndex + 1;
				this.batchFields.splice(insertIndex, 0, tempItem);
				for(let i=0; i<this.batchFields.length; i++){
					this.batchFields[i].orderNumber = i + 1;
				}
			},

			fn_isMoveDownDisabled: function(){
				let itemIndex = this.batchFields.findIndex(item=>{return item.selected});
				if(itemIndex == this.batchFields.length - 1 || itemIndex == -1){
					return true;
				}
				else{
					return false;
				}
			},

			fn_isMoveUpDisabled: function(){
				let itemIndex = this.batchFields.findIndex(item=>{return item.selected});
				if(itemIndex == 0 || itemIndex == -1){
					return true;
				}
				else{
					return false;
				}
			},

			fn_openDialogAddFields: function(){
				this.dialogBatchFields = true;
				this.reorder = false;
			},

			fn_postList: function(){
				var self = this;
				let dataObj = {"listsId":"prescribe_by_details","name":"Doctors","title":"Doctors","description":"Details of prescriber","groupTypeId":401,"isSystem":1}
				this.postData('Lists', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
		        // this.fn_goBack();
			},

			fn_openDialogTextContent: function(type){
				this.textDialogType = type;
				if(type == 'yousaved'){
					this.textDialogTitle = "Saving Text";
					this.dialogTextContent = this.ThermalPrintSettings.thermalSavingText ? this.ThermalPrintSettings.thermalSavingText : "You Saved";
				}
				if(type == 'terms'){
					this.textDialogTitle = "Terms & Conditions";
					this.dialogTextContent = this.ThermalPrintSettings.thermalTermsText ? this.ThermalPrintSettings.thermalTermsText : "All disputes are subject to "+this.$root.CurrentBusiness.State+" jurisdiction";
				}
				if(type == 'greeting'){
					this.textDialogTitle = "Footer Message";
					this.dialogTextContent = this.ThermalPrintSettings.thermalGreetingText ? this.ThermalPrintSettings.thermalGreetingText : "Thank you! Visit again soon!";
				}
				if(type == 'business_name'){
					this.textDialogTitle = "Business Name";
					this.dialogTextContent = this.ThermalPrintSettings.thermalBusinessName ? this.ThermalPrintSettings.thermalBusinessName : this.$root.CurrentBusiness.BusinessName;
				}
                if(type == 'business_info'){
					this.textDialogTitle = "Business Info";
					this.dialogTextContent = this.ThermalPrintSettings.thermalBusinessInfo ? this.ThermalPrintSettings.thermalBusinessInfo : this.$root.CurrentBusiness.Address;
				}
                this.$forceUpdate();
				setTimeout(() => {
					this.fn_openDialogWeb('web', 'DialogText', 'ref_dialogText');
				}, 100);
			},

			fn_saveText: function(content){
				if(this.textDialogType=='yousaved'){
					this.ThermalPrintSettings.thermalSavingText = content;
				}
				else if(this.textDialogType=='terms'){
					this.ThermalPrintSettings.thermalTermsText = content;
				}
				else if(this.textDialogType=='greeting'){
					this.ThermalPrintSettings.thermalGreetingText = content;
				}
                else if(this.textDialogType=='business_name'){
					this.ThermalPrintSettings.thermalBusinessName = content;
				}
                else if(this.textDialogType=='business_info'){
					this.ThermalPrintSettings.thermalBusinessInfo = content;
				}
				this.$forceUpdate();
				this.fn_post();
				this.fn_closeDialog();
			},

            fn_togglePaperCut: function(value){
                this.ThermalPrintSettings.paperCut = value;
				this.fn_post();
            },
            
            fn_toggleItemDescription: function(value){
                this.ThermalPrintSettings.itemDescription = value;
				this.fn_post();
            },

            fn_toggleItemNote: function(value){
                this.ThermalPrintSettings.itemNote = value;
				this.fn_post();
            },

            fn_toggleItemBrand: function(value){
                this.ThermalPrintSettings.itemBrand = value;
				this.fn_post();
            },

            fn_toggleItemCompany: function(value){
                this.ThermalPrintSettings.itemCompany = value;
				this.fn_post();
            },

            fn_toggleItemCategory: function(value){
                this.ThermalPrintSettings.itemCategory = value;
				this.fn_post();
            },

            fn_toggleItemUnit: function(value){
                this.ThermalPrintSettings.itemUnit = value;
				this.fn_post();
            },

            fn_toggleItemCode: function(value){
                this.ThermalPrintSettings.itemCode = value;
				this.fn_post();
            },

			fn_toggleItemRate: function(value){
                this.ThermalPrintSettings.itemRate = value;
				this.fn_post();
            },

			fn_toggleItemDiscount: function(value){
				this.ThermalPrintSettings.itemDiscount = value;
				this.fn_post();
			},

			fn_toggleItemGST: function(value){
				this.ThermalPrintSettings.itemGst = value;
				this.fn_post();
			},

			fn_toggleItemNetAmount: function(value){
				this.ThermalPrintSettings.itemNetAmount = value;
				this.fn_post();
			},

            fn_toggleRemainingAmount: function(value){
                this.ThermalPrintSettings.remainingAmount = value;
				this.fn_post();
            },

            fn_saveNumberOfCopies: function(){
                if(this.ThermalPrintSettings.numberOfCopies < 1 || this.ThermalPrintSettings.numberOfCopies > 5){
                    this.showToast("Number of copies can be 1 to 5");
                }
                else{
                    this.fn_post();
                }
            },

            fn_saveLinesAtEnd: function(){
                if(this.ThermalPrintSettings.linesAtEnd < 1 || this.ThermalPrintSettings.linesAtEnd > 5){
                    this.showToast("Lines at end can be 1 to 5");
                }
                else{
                    this.fn_post();
                }
            },

            fn_getDefaultPrinter: function () {
				let self = this;
				this.getData('DefaultBluetoothPrinter', null, 
					{
					onSuccess: function(response){
						console.log(response);
						let data = JSON.parse(response);
						if(data.address && data.name){
							self.defaultPrinter = data.name;
						}
					}, 
					onError: function(error){
						console.log(error);
					}
				});
			},

            fn_toDevices: function(){
                this.$router.push({path:'/settings/bluetoothdevices', query:{"setdefault":1}});
            },

			fn_savePageSize: function(size){
				this.ThermalPrintSettings.pageSize = size;
				this.fn_post();
			},

			fn_getPageSize: function(){
				if(this.ThermalPrintSettings.pageSize == 2){
					return '2 Inch (58mm)';
				}
				if(this.ThermalPrintSettings.pageSize == 2.1){
					return '2 Inch Large Font (58mm)';
				}
				if(this.ThermalPrintSettings.pageSize == 3.01){
					return '3 Inch (Compact)';
				}
				if(this.ThermalPrintSettings.pageSize == 2.01){
					return '2 Inch (Compact)';
				}
				if(this.ThermalPrintSettings.pageSize == 2.02){
					return '2 Inch Large Font (Compact)';
				}
				if(this.ThermalPrintSettings.pageSize == 4){
					return '4 Inch';
				}
				if(this.ThermalPrintSettings.pageSize == 4.1){
					return '4 Inch Large Font';
				}
				else{
					return '3 Inch (80mm)';
				}
			},

			fn_toggleBiggerTotal: function(value){
				this.ThermalPrintSettings.invoiceTotalBigger = value;
				this.fn_post();
			},

			// fn_toggleImagePrint: function(value){
			// 	this.ThermalPrintSettings.imagePrint = value;
			// 	this.fn_post();
			// }
	  	},

	  	mounted: function(){
	  		this.formId = this.guidWeb();
			this.dialogStorageId = 'dialog_'+this.formId;
	  		window.js_globals.fn_onBackPress = this.fn_goBack;

            this.thermalBusinessInfo = '';
            if(this.$root.CurrentBusiness.Address){
                this.thermalBusinessInfo = this.thermalBusinessInfo + this.$root.CurrentBusiness.Address
            }
            if(this.$root.CurrentBusiness.GSTNumber){
                this.thermalBusinessInfo ? this.thermalBusinessInfo = this.thermalBusinessInfo + '\n' : '';
                this.thermalBusinessInfo = this.thermalBusinessInfo + 'GSTIN: ' + this.$root.CurrentBusiness.GSTNumber;
            }
           
            this.$root.fn_getLocalItem('ThermalPrintSettings', response=>{
                let data = JSON.parse(response);
				if(data && data.LocalValue){
					this.ThermalPrintSettings = JSON.parse(data.LocalValue);

					// assigning values to later added configs and saving
					if(this.ThermalPrintSettings.itemDiscount === undefined || this.ThermalPrintSettings.itemGst === undefined || this.ThermalPrintSettings.itemNetAmount === undefined){
						this.ThermalPrintSettings.itemDiscount === undefined ? this.ThermalPrintSettings.itemDiscount = true : '';
						this.ThermalPrintSettings.itemGst === undefined ? this.ThermalPrintSettings.itemGst = true : '';
						this.ThermalPrintSettings.itemNetAmount === undefined ? this.ThermalPrintSettings.itemNetAmount = true : '';
						this.fn_post();
					}
				}
			});

            this.fn_getDefaultPrinter();
	  	},
	  	beforeRouteLeave (to, from, next) {
	    	var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
				dialogjs.fn_checkAndCloseOpenDialogs(this);
				next(false);
			}
			else if(this.askToQuit){
				this.fn_openDialogConfirmation();
				next(false);
			}
			else{
				next();
			}
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/print_settings/thermal_print.vue